import React from 'react'

export default function LoadingOverlay({loading}) {

    if(!loading)
        return <></>

    return (
        <div className="loading-overlay">             
            <div className="lds-ring"><div></div><div></div><div></div><div></div></div>       
        </div>
    )
}